import { Injectable } from '@angular/core';
import { Design, DesignApiService } from '@ansys/cloud-angular-client';
import {
  AWFAction,
  ActionContributionsService,
  WorkspaceTabSection,
} from '@ansys-internal/awf-angular/contributions';
import {
  AWFFile,
  DialogService,
  ProductContextService,
} from '@ansys-internal/awf-angular/shared';
import { lastValueFrom } from 'rxjs';
import { ActionsEnum } from 'src/app/actions/actions.enum';
import { ConceptService } from 'src/app/shared/services/concept.service';
import { LoadingComponent } from 'src/app/components/dialogs/loading/loading.component';
import {
  CreateDesignAction,
  CreateDesignOutput,
} from '@ansys-internal/awf-angular/dashboard';
import { State } from '@ansys-internal/awf-angular/store';
import { AuthSessionService } from '@ansys-internal/awf-angular/auth';

type InputType = { projectId: string; designToClone?: AWFFile };
type ReturnType = CreateDesignOutput;

@Injectable({
  providedIn: 'root',
})
export class DesignCreateAction implements AWFAction<InputType, ReturnType> {
  public readonly type = ActionsEnum.COMPOSE_FULL_DATASET;

  projectSection!: WorkspaceTabSection | undefined;
  constructor(
    private designAPIService: DesignApiService,
    private productContextService: ProductContextService,
    private conceptService: ConceptService,
    private actions: ActionContributionsService,
    private dialog: DialogService,
    private state: State,
    private authSessionService: AuthSessionService
  ) {}

  execute: (context: InputType) => Promise<ReturnType> = async (
    context: InputType
  ) => {
    await this.waitFor(() => this.authSessionService.authenticated);

    const loadingRef = this.dialog.open(LoadingComponent, {
      title: 'Creating your new Concept',
    });

    const { projectId } = context;
    const productId = (await this.productContextService.getProduct())
      ?.partNumber;
    const requestBody = {
      request: {
        projectId,
        productId,
        designTitle: 'Branch 1',
        designDescription: '',
      },
      isRootFile: true,
    };

    const design = await this.actions.execute(CreateDesignAction, requestBody);

    loadingRef.close();

    return design;
  };

  waitFor(fn: () => boolean): Promise<void> {
    return new Promise((resolve) => {
      const localFn = (): void => {
        fn() ? resolve() : setTimeout(localFn, 1000);
      };
      localFn();
    });
  }
}
